// Hardcoded price range bounds for the search slider, anchored to EUR ≈ 1000.
// Backend can't reliably compute per-search min/max yet, so the slider falls
// back to these approximate per-currency ceilings. Replace with backend-driven
// bounds once the search service exposes them.

export const PRICE_RANGE_MIN_DEFAULT = 0;
export const PRICE_RANGE_MAX_FALLBACK = 1000;

// The price range slider is gated on a custom attribute the operator adds in the
// Instore admin: titled "Price" (matched case-insensitively) and configured
// WITHOUT options. That option-less attribute drives the slider instead of a
// list of selectable values. See isPriceCustomAttribute in utils/attributes.ts.
export const PRICE_CUSTOM_ATTRIBUTE_TITLE = "price";

export const PRICE_RANGE_MAX_BY_CURRENCY: Record<string, number> = {
  EUR: 1000,
  GBP: 850,
  CHF: 950,
  DKK: 7500,
  SEK: 11000,
  NOK: 11500,
  PLN: 4500,
  CZK: 25000,
  HUF: 400000,
  RON: 5000,
};
